<template>

  <pie-chart v-if="chart" :data="chart.data"
   :donut="true"
   :legend="showLegend ? posLegend : null"
   :colors="chart.colors">
   </pie-chart>


</template>

<script>

import ChartMixins from '@/mixins/ChartMixins'

export default {

  mixins: [ChartMixins],

  props: {

    stats: {
      type: Object,
      default: null
    },

    showLegend: {
      type: Boolean,
      default: true
    },

    posLegend: {
      type: String,
      default: 'right'
    },

    // XOL-696: opt-in slice set — [{ key: 'sitesActive', label: 'Active', color: '#409EFF' }, ...],
    // drawn in the order given. null (every host but the Sharers Summary popup) keeps the
    // default seven-slice list and palette below.
    slices: {
      type: Array,
      default: null
    }
  },

  data () {

    return {
      chart: null,
      st: (this.stats ? this.stats : this.getStats())
    }

  },


  created () {
    var st = this.st

    if (this.slices) {
      this.chart = this.preparePieChart(
        this.slices.map(function (sl) { return [sl.label + ' Sites (' + st[sl.key] + ')', st[sl.key]] }),
        this.slices.map(function (sl) { return sl.color })
      )
      return
    }

    this.chart = this.preparePieChart([
      ['Active Sites (' + this.st.sitesActive + ')', this.st.sitesActive],
      ['Dismantled Sites (' + this.st.sitesDismantled + ')', this.st.sitesDismantled],
      ['Temporary Sites (' + this.st.sitesTemporary + ')', this.st.sitesTemporary],
      ['New Sites (' + this.st.sitesNew + ')', this.st.sitesNew],
      ['Exclusive Sites (' + this.st.sitesExclusive + ')', this.st.sitesExclusive],
      ['Candidate Sites (' + this.st.sitesCandidate + ')', this.st.sitesCandidate],
      ['Land Only Sites (' + this.st.sitesLandOnly + ')', this.st.sitesLandOnly]
    ],
    ['#409EFF', '#F56C6C', '#909399', '#67C23A', '#303133', '#E6A23C', '#C0C4CC'])

  }

}

</script>
